import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconMotion = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={13}
      height={10}
      fill="none"
      viewBox="0 0 13 10"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <circle cx="4.86736" cy="4.86718" r="4.86736" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.91618 4.86733C3.91618 4.46602 4.17556 4.14069 4.49553 4.14069L11.3171 4.14069C11.6371 4.14069 11.8964 4.46602 11.8964 4.86733C11.8964 5.26865 11.6371 5.59398 11.3171 5.59398L4.49553 5.59398C4.17556 5.59398 3.91618 5.26865 3.91618 4.86733Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.56226 2.0859C7.56226 1.68458 7.80954 1.35925 8.11458 1.35925L12.0327 1.35925C12.3377 1.35925 12.585 1.68458 12.585 2.0859C12.585 2.48721 12.3377 2.81254 12.0327 2.81254L8.11458 2.81254C7.80954 2.81254 7.56226 2.48721 7.56226 2.0859Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.56226 7.6484C7.56226 7.24708 7.80954 6.92175 8.11458 6.92175L12.0327 6.92175C12.3377 6.92175 12.585 7.24708 12.585 7.6484C12.585 8.04971 12.3377 8.37504 12.0327 8.37504L8.11458 8.37504C7.80954 8.37504 7.56226 8.04971 7.56226 7.6484Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
